import { Flex } from "@qws-org/ui-kit";
import type { FC } from "react";
import React from "react";

import { SliderArrow } from "~/icons";

type DesktopNavigationColumnProps = {
  direction?: "left" | "right";
};
export const DesktopNavigationColumn: FC<DesktopNavigationColumnProps> = ({
  direction,
}) => {
  return (
    <Flex
      justify="center"
      display="hidden"
      d={{ display: "flex", maxWidth: 340 }}
      cursor="pointer"
      align={"center"}
      groupParent={true}
      width="100%"
      className={direction === "left" ? "custom-prev" : "custom-next"}
    >
      <SliderArrow
        className={`${direction === "left" ? "" : "rotate-180"} invisible group-hover:visible `}
      />
    </Flex>
  );
};
